/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10.5 7L9.5 17M14.5 7L13.5 17M7.625 10L17 10M7 14L16.375 14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H12.4C15.7603 2 17.4405 2 18.7239 2.65396C19.8529 3.2292 20.7708 4.14708 21.346 5.27606C22 6.55953 22 8.23969 22 11.6V12.4C22 15.7603 22 17.4405 21.346 18.7239C20.7708 19.8529 19.8529 20.7708 18.7239 21.346C17.4405 22 15.7603 22 12.4 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="6"
				fill="currentColor"
			/>
			<path
				d="M10.5 7L10.2 10M10.2 10L9.8 14M10.2 10H7.625M10.2 10H14.2M9.8 14L9.5 17M9.8 14H7M9.8 14H13.8M14.5 7L14.2 10M14.2 10L13.8 14M14.2 10L17 10M13.8 14L13.5 17M13.8 14H16.375M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.52606 1.90396C5.80953 1.25 7.48969 1.25 10.85 1.25H13.15C16.5103 1.25 18.1905 1.25 19.4739 1.90396C20.6029 2.4792 21.5208 3.39709 22.096 4.52606C22.75 5.80953 22.75 7.48969 22.75 10.85V13.15C22.75 16.5103 22.75 18.1905 22.096 19.4739C21.5208 20.6029 20.6029 21.5208 19.4739 22.096C18.1905 22.75 16.5103 22.75 13.15 22.75H10.85C7.48969 22.75 5.80953 22.75 4.52606 22.096C3.39708 21.5208 2.4792 20.6029 1.90396 19.4739C1.25 18.1905 1.25 16.5103 1.25 13.15V10.85C1.25 7.48969 1.25 5.80953 1.90396 4.52606C2.4792 3.39708 3.39709 2.4792 4.52606 1.90396ZM11.2463 7.07463C11.2875 6.66247 10.9868 6.29494 10.5746 6.25372C10.1625 6.21251 9.79494 6.51321 9.75372 6.92537L9.52126 9.25H7.625C7.21079 9.25 6.875 9.58579 6.875 10C6.875 10.4142 7.21079 10.75 7.625 10.75H9.37126L9.12126 13.25H7C6.58579 13.25 6.25 13.5858 6.25 14C6.25 14.4142 6.58579 14.75 7 14.75H8.97126L8.75372 16.9254C8.71251 17.3375 9.01321 17.7051 9.42537 17.7463C9.83753 17.7875 10.2051 17.4868 10.2463 17.0746L10.4787 14.75H12.9713L12.7537 16.9254C12.7125 17.3375 13.0132 17.7051 13.4254 17.7463C13.8375 17.7875 14.2051 17.4868 14.2463 17.0746L14.4787 14.75H16.375C16.7892 14.75 17.125 14.4142 17.125 14C17.125 13.5858 16.7892 13.25 16.375 13.25H14.6287L14.8787 10.75H17C17.4142 10.75 17.75 10.4142 17.75 10C17.75 9.58579 17.4142 9.25 17 9.25H15.0287L15.2463 7.07463C15.2875 6.66247 14.9868 6.29494 14.5746 6.25372C14.1625 6.21251 13.7949 6.51321 13.7537 6.92537L13.5213 9.25H11.0287L11.2463 7.07463ZM10.6287 13.25L10.8787 10.75H13.3713L13.1213 13.25H10.6287Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C8.07116 2 7.60674 2 7.21684 2.05133C4.52444 2.40579 2.40579 4.52444 2.05133 7.21684C2 7.60674 2 8.07116 2 9L2 12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14709 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V9C22 8.07116 22 7.60674 21.9487 7.21684C21.5942 4.52444 19.4756 2.40579 16.7832 2.05133C16.3933 2 15.9288 2 15 2V2L14.5 2M10.5 7L9.5 17M14.5 7L13.5 17M7.625 10L17 10M7 14H16.375"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M10.5 7L9.5 17M14.5 7L13.5 17M7.625 10L17 10M7 14H16.375M11.6 22H12.4C15.7603 22 17.4405 22 18.7239 21.346C19.8529 20.7708 20.7708 19.8529 21.346 18.7239C22 17.4405 22 15.7603 22 12.4V11.6C22 8.23969 22 6.55953 21.346 5.27606C20.7708 4.14708 19.8529 3.2292 18.7239 2.65396C17.4405 2 15.7603 2 12.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V12.4C2 15.7603 2 17.4405 2.65396 18.7239C3.2292 19.8529 4.14708 20.7708 5.27606 21.346C6.55953 22 8.23969 22 11.6 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M10.85 1.25C7.48969 1.25 5.80953 1.25 4.52606 1.90396C3.39709 2.4792 2.4792 3.39708 1.90396 4.52606C1.25 5.80953 1.25 7.48969 1.25 10.85L1.25 13.15C1.25 16.5103 1.25 18.1905 1.90396 19.4739C2.4792 20.6029 3.39708 21.5208 4.52606 22.096C5.80953 22.75 7.48969 22.75 10.85 22.75H13.15C16.5103 22.75 18.1905 22.75 19.4739 22.096C20.6029 21.5208 21.5208 20.6029 22.096 19.4739C22.75 18.1905 22.75 16.5103 22.75 13.15V10.85C22.75 7.48969 22.75 5.80953 22.096 4.52606C21.5208 3.39709 20.6029 2.4792 19.4739 1.90396C18.1905 1.25 16.5103 1.25 13.15 1.25L10.85 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5746 6.25378C10.9868 6.29499 11.2875 6.66253 11.2463 7.07468L11.0287 9.25006H13.5213L13.7537 6.92543C13.7949 6.51327 14.1625 6.21256 14.5746 6.25378C14.9868 6.29499 15.2875 6.66253 15.2463 7.07468L15.0287 9.25006H17C17.4142 9.25006 17.75 9.58584 17.75 10.0001C17.75 10.4143 17.4142 10.7501 17 10.7501H14.8787L14.6287 13.2501H16.375C16.7892 13.2501 17.125 13.5858 17.125 14.0001C17.125 14.4143 16.7892 14.7501 16.375 14.7501H14.4787L14.2463 17.0747C14.2051 17.4868 13.8375 17.7875 13.4254 17.7463C13.0132 17.7051 12.7125 17.3376 12.7537 16.9254L12.9713 14.7501L10.4787 14.7501L10.2463 17.0747C10.2051 17.4868 9.83753 17.7875 9.42537 17.7463C9.01321 17.7051 8.71251 17.3376 8.75372 16.9254L8.97126 14.7501H7C6.58579 14.7501 6.25 14.4143 6.25 14.0001C6.25 13.5858 6.58579 13.2501 7 13.2501H9.12126L9.37126 10.7501H7.625C7.21079 10.7501 6.875 10.4143 6.875 10.0001C6.875 9.58584 7.21079 9.25006 7.625 9.25006H9.52126L9.75372 6.92543C9.79494 6.51327 10.1625 6.21256 10.5746 6.25378ZM10.8787 10.7501L10.6287 13.2501L13.1213 13.2501L13.3713 10.7501H10.8787Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
